import * as React from "react";
/**
 * Logger context
 */ export const LoggerContext = React.createContext(undefined);
/** Logger Context Provider */ export const LoggerContextProvider = LoggerContext.Provider;
